export const Icon = {
  breath: (s = 24) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round">
      <path d="M3 12c2 0 2-3 4-3s2 3 4 3 2-3 4-3 2 3 4 3" />
      <path d="M3 16c2 0 2-3 4-3s2 3 4 3 2-3 4-3 2 3 4 3" opacity="0.5" />
    </svg>
  ),
  sound: (s = 24) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round">
      <circle cx="12" cy="12" r="2" />
      <circle cx="12" cy="12" r="5.5" opacity="0.6" />
      <circle cx="12" cy="12" r="9" opacity="0.3" />
    </svg>
  ),
  emotion: (s = 24) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 20s-7-4.5-7-10a4 4 0 017-2.6A4 4 0 0119 10c0 5.5-7 10-7 10z" />
    </svg>
  ),
  daily: (s = 24) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round">
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </svg>
  ),
  body: (s = 24) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round">
      <circle cx="12" cy="5" r="2" />
      <path d="M12 8v8M8 11h8M9 20l3-4 3 4" />
    </svg>
  ),
  space: (s = 24) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4">
      <circle cx="12" cy="12" r="9" />
      <circle cx="12" cy="12" r="1.4" fill="currentColor" />
    </svg>
  ),
  sleep: (s = 24) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 14.5A8 8 0 119.5 4a6.5 6.5 0 0010.5 10.5z" />
    </svg>
  ),
  love: (s = 24) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 20s-7-4.5-7-10a4 4 0 017-2.6A4 4 0 0119 10c0 5.5-7 10-7 10z" />
      <path d="M9 11l2 2 4-4" opacity="0.5" />
    </svg>
  ),
  brain: (s = 24) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4">
      <path d="M9 6a3 3 0 013 3v6a3 3 0 01-6 0V9a3 3 0 013-3z" />
      <path d="M15 6a3 3 0 00-3 3v6a3 3 0 006 0V9a3 3 0 00-3-3z" />
    </svg>
  ),
  phone: (s = 24) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4">
      <rect x="7" y="3" width="10" height="18" rx="2" />
      <circle cx="12" cy="17.5" r="0.7" fill="currentColor" />
    </svg>
  ),
  flame: (s = 24) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round">
      <path d="M12 3c1 4 5 5 5 9a5 5 0 11-10 0c0-2 1-3 2-4 0 2 1 3 2 3-1-2 0-5 1-8z" />
    </svg>
  ),
  fear: (s = 24) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" strokeLinecap="round">
      <path d="M5 9l2-4h10l2 4M5 9v9a2 2 0 002 2h10a2 2 0 002-2V9M5 9h14" />
      <path d="M10 14l1 1M14 14l-1 1" />
    </svg>
  ),
  battery: (s = 24) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4">
      <rect x="3" y="8" width="16" height="8" rx="2" />
      <rect x="6" y="10.5" width="3" height="3" fill="currentColor" stroke="none" />
      <path d="M21 11v2" />
    </svg>
  ),
  moon: (s = 24) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round">
      <path d="M20 14.5A8 8 0 119.5 4a6.5 6.5 0 0010.5 10.5z" />
    </svg>
  ),
  heart: (s = 24) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round">
      <path d="M12 20s-7-4.5-7-10a4 4 0 017-2.6A4 4 0 0119 10c0 5.5-7 10-7 10z" />
    </svg>
  ),
  focus: (s = 24) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4">
      <circle cx="12" cy="12" r="3" />
      <circle cx="12" cy="12" r="8" />
    </svg>
  ),
  spark: (s = 24) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round">
      <path d="M12 3l2 6 6 2-6 2-2 6-2-6-6-2 6-2z" />
    </svg>
  ),
  silence: (s = 24) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round">
      <circle cx="12" cy="12" r="9" />
      <path d="M8 12h8" />
    </svg>
  ),
  arrow: (s = 14) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
      <path d="M5 12h14M13 5l7 7-7 7" />
    </svg>
  ),
  arrowSm: (s = 12) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <path d="M5 12h14M13 5l7 7-7 7" />
    </svg>
  ),
  student: (s = 22) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round">
      <path d="M2 9l10-5 10 5-10 5z" /><path d="M6 11v5c0 1 3 2 6 2s6-1 6-2v-5" />
    </svg>
  ),
  brief: (s = 22) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4">
      <rect x="3" y="7" width="18" height="13" rx="2" /><path d="M8 7V5a2 2 0 012-2h4a2 2 0 012 2v2" />
    </svg>
  ),
  parents: (s = 22) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round">
      <circle cx="8" cy="7" r="2.5" /><circle cx="16" cy="7" r="2.5" /><path d="M3 20c0-3 2.5-5 5-5s5 2 5 5M14 20c0-3 2-5 4-5s3 2 3 5" />
    </svg>
  ),
  creator: (s = 22) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round">
      <path d="M12 19l-7-7 7-7 7 7-7 7z" /><circle cx="12" cy="12" r="1.4" fill="currentColor" stroke="none" />
    </svg>
  ),
  scroll: (s = 22) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4">
      <rect x="7" y="3" width="10" height="18" rx="2" />
      <path d="M10 7h4M9 11l1.5 1.5L13 10" />
    </svg>
  ),
  still: (s = 22) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4">
      <circle cx="12" cy="12" r="9" /><path d="M9 12h6" />
    </svg>
  ),
  seek: (s = 22) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round">
      <path d="M12 3l2 6 6 2-6 2-2 6-2-6-6-2 6-2z" />
    </svg>
  ),
  text: (s = 24) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round">
      <path d="M4 6h16M4 12h16M4 18h10" />
    </svg>
  ),
  audio: (s = 24) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round">
      <path d="M4 14V10M8 17V7M12 20V4M16 17V7M20 14V10" />
    </svg>
  ),
  language: (s = 24) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round">
      <path d="M3 5h14M9 5v14M5 5l4 14M11 13c1 3 4 5 9 6" />
    </svg>
  ),
  bell: (s = 24) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round">
      <path d="M6 16V11a6 6 0 0112 0v5l2 2H4l2-2zM10 20a2 2 0 004 0" />
    </svg>
  ),
  journal: (s = 24) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4">
      <path d="M5 3h12a2 2 0 012 2v16l-4-2-4 2-4-2-2 1V5a2 2 0 012-2z" />
    </svg>
  ),
  community: (s = 24) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round">
      <circle cx="9" cy="9" r="3" /><circle cx="17" cy="10" r="2.4" />
      <path d="M3 20c0-3 2.5-5 6-5s6 2 6 5M15 20c0-2 1.5-4 4-4s2 2 2 4" />
    </svg>
  ),
};

export const familyMeta = {
  breath: { label: "Breath", icon: Icon.breath, blurb: "Breath origins, turns, meeting points, and natural stillness.", count: 7 },
  sound: { label: "Sound", icon: Icon.sound, blurb: "AUM, vowels, fading music, inner sound, and mantra.", count: 12 },
  body: { label: "Body", icon: Icon.body, blurb: "Subtle channels, posture, touch, senses, and embodied attention.", count: 20 },
  emotion: { label: "Emotion", icon: Icon.emotion, blurb: "Bliss, strong emotion, equanimity, and the center between reactions.", count: 7 },
  space: { label: "Space & Void", icon: Icon.space, blurb: "Sky, darkness, emptiness, self-inquiry, and nondual contemplation.", count: 48 },
  sleep: { label: "Sleep & Dream", icon: Icon.sleep, blurb: "The threshold of sleep and the three states of consciousness.", count: 2 },
  love: { label: "Love & Devotion", icon: Icon.love, blurb: "Intimacy, reunion, shared consciousness, devotion, and detachment.", count: 6 },
  daily: { label: "Daily Life", icon: Icon.daily, blurb: "Ordinary desire, eating, movement, senses, thought, and identity as practice.", count: 10 },
};
